/**
 * HighlightColorButton
 * Toolbar button for setting highlight/background color
 */
import React from 'react';
import { HIGHLIGHT_COLORS } from '../constants';
import { getHighlightColor, setHighlightColor } from '../editor.utils';
import ColorPickerButton from './ColorPickerButton';

const HighlightColorButton = () => {
  return (
    <ColorPickerButton
      icon='border_color'
      title='Highlight color'
      colors={HIGHLIGHT_COLORS as { name: string; value: string }[]}
      getColor={getHighlightColor}
      setColor={setHighlightColor}
      removeLabel='Remove highlight'
      showIndicator={false}
      gridColumns={5}
    />
  );
};

HighlightColorButton.displayName = 'HighlightColorButton';

export default HighlightColorButton;
